import { useQuery } from '@tanstack/react-query';

import { journalApi } from '@/domain/journal/api';
import { journalKeys } from '@/domain/journal/queries/keys';
import { toJEIndexFormFields } from '@/domain/journal/schemas';
import { queryOptions } from '@/services/query';

type JEIndexFormArgs = {
  companyId: string | null;
  documentID: string;
  cellName: string;
  cellValue: string;
};

export const jeIndexFormQuery = ({ companyId, documentID, cellName, cellValue }: JEIndexFormArgs) =>
  queryOptions({
    queryKey: journalKeys.indexForm(companyId, documentID, cellName, cellValue),
    queryFn: async () =>
      toJEIndexFormFields(
        await journalApi.getIndexForm({ query: { field: cellName, value: cellValue, document_id: documentID } }),
      ),
    // Nothing is kept between opens. `defaultValues` are read once, at mount,
    // and a background refetch cannot reseed a mounted form — so a cached
    // answer would hand the user a form filled from a stale snapshot. This is
    // also the previous behaviour: every open is a fresh read behind a spinner.
    cacheTime: 0,
    // A retry would only hold the dialog on its spinner longer than the saga
    // did; the outcome is the same dialog either way.
    retry: false,
    // The mounted form ignores a refetch, so a focus regain has nothing to do.
    refetchOnWindowFocus: false,
  });

export const useJEIndexForm = (args: JEIndexFormArgs) => useQuery(jeIndexFormQuery(args));
